import { redirect } from 'react-router-dom';

import { receiptsActions } from 'app-components/flux/receipts';

import type { AppDispatch } from 'store';

export const loadReceiptCenter = (receiptCenterEnabled: boolean, dispatch: AppDispatch): Response | null => {
  if (!receiptCenterEnabled) {
    return redirect('/oops');
  }

  dispatch(receiptsActions.setReceiptCenterQueryMode(true));
  dispatch(receiptsActions.invalidateReceiptCenter(false));
  return null;
};
